const loadChat = (state, { payload: id }) => {
    if (state.loadedChats.indexOf(id) === -1) state.loadedChats.push(id);
};

export default loadChat;
